export const ORDERED_LEADS = [
  'MLI',
  'MLII',
  'MLIII',
  'AVR',
  'AVL',
  'AVF',
  'V1',
  'V2',
  'V3',
  'V4',
  'V5',
  'V6',
];

export const sortLeads = (a: string, b: string) => {
  return ORDERED_LEADS.indexOf(a) - ORDERED_LEADS.indexOf(b);
};

const LEAD_NAME_MAP: Record<string, string> = {
  AVF: 'aVF',
  AVL: 'aVL',
  AVR: 'aVR',
  MLI: 'I',
  MLII: 'II',
  MLIII: 'III',
  V1: 'V1',
  V2: 'V2',
  V3: 'V3',
  V4: 'V4',
  V5: 'V5',
  V6: 'V6',
};

export const parseLeadName = (lead: string) => LEAD_NAME_MAP[lead] ?? lead;

export const inverseParseLeadName = (parsedLeadName: string) =>
  Object.keys(LEAD_NAME_MAP).find(
    (lead) => LEAD_NAME_MAP[lead] === parsedLeadName,
  ) as string;
